export default __webpack_public_path__ + "static/media/BgMobil.ff47e11f.png";